import { render, staticRenderFns } from "./InputPlaceholder.vue?vue&type=template&id=3f7ccb39"
import script from "./InputPlaceholder.vue?vue&type=script&lang=ts"
export * from "./InputPlaceholder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f7ccb39')) {
      api.createRecord('3f7ccb39', component.options)
    } else {
      api.reload('3f7ccb39', component.options)
    }
    module.hot.accept("./InputPlaceholder.vue?vue&type=template&id=3f7ccb39", function () {
      api.rerender('3f7ccb39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/skeletonPlaceholder/components/InputPlaceholder.vue"
export default component.exports